<template>
  <section class="box scanning">
     <video id="video" width="680" height="600" autoplay muted ></video>
     <div id="canvas"></div>
  </section>
</template>

<script>
import * as faceapi from 'face-api.js';
import store from "./../store";

export default {
  name: 'Video',
  data: () => ({
    video : "",
    canvas:"",
    userInfo:{},
    faceAPIInterval:null,
    videoStream:null,
    labeledFaceDescriptors:null,
   }),
  methods: {
    loadLabeledImages() {
      const labels = ['Atul', 'John']
      return Promise.all(
        labels.map(async label => {
          const descriptions = []
          for (let i = 1; i <= 2; i++) {
            console.log(label[i])
            const img = await faceapi.fetchImage(`https://cogneetive-face-detection.s3.amazonaws.com/labeled_images/${label}/${i}.jpg`)
            const detections = await faceapi.detectSingleFace(img).withFaceLandmarks().withFaceDescriptor()
            descriptions.push(detections.descriptor)
          }
          return new faceapi.LabeledFaceDescriptors(label, descriptions)
        })
      )
    },
    startVideo() {
      let self= this;
      console.log('Starting video')
      window.navigator.getUserMedia(
        { video: {} },
        stream => self.video.srcObject = stream,
        err => console.error(err)
      )
    }
  },
  mounted() {

    this.video = document.getElementById('video');
    this.canvasContainer = document.getElementById('canvas');
    this.userInfo= JSON.parse(localStorage.getItem("currentUser")) 
    console.log(store)
    this.startVideo();
    this.video.addEventListener('play', async () => {
        const canvas = faceapi.createCanvasFromMedia(this.video);
        const displaySize = { width: this.video.width, height: this.video.height };
        this.labeledFaceDescriptors = await this.loadLabeledImages()
        this.canvasContainer.appendChild(canvas)
        const faceMatcher = new faceapi.FaceMatcher(this.labeledFaceDescriptors, 0.6)
        faceapi.matchDimensions(canvas, displaySize)
        this.faceAPIInterval = setInterval(async () => {
          console.log(this.labeledFaceDescriptors)
          const detections = await faceapi.detectAllFaces(this.video, new faceapi.TinyFaceDetectorOptions()).withFaceLandmarks().withFaceDescriptors()
          const resizedDetections = faceapi.resizeResults(detections, displaySize)
          canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height)
          const results = resizedDetections.map(d => faceMatcher.findBestMatch(d.descriptor))
          if(this.userInfo.name.indexOf(results[0]._label)!=-1){
         
            setTimeout(() => {
                 clearInterval(this.faceAPIInterval);
                  Event.$emit("scannCompleted", { msg:results[0]._label });
                  
            }, 2000);
          }
          results.forEach((result, i) => {
            const box = resizedDetections[i].detection.box
            const drawBox = new faceapi.draw.DrawBox(box, { label: result.toString() })
            drawBox.draw(canvas)
          })
        }, 40)
      })
  },

}
</script>


<style scoped>
#canvas{
    position: absolute;
    display: inline;
    top: 0;
    left: 0;
    margin-block: 50px;
}
</style>
